__turbopack_context__.v({
  "btn": "button-module-scss-module__csTmNG__btn",
  "danger": "button-module-scss-module__csTmNG__danger",
  "default": "button-module-scss-module__csTmNG__default",
  "disabledOrLoading": "button-module-scss-module__csTmNG__disabledOrLoading",
  "ghost": "button-module-scss-module__csTmNG__ghost",
  "primary": "button-module-scss-module__csTmNG__primary",
  "secondary": "button-module-scss-module__csTmNG__secondary",
  "success": "button-module-scss-module__csTmNG__success",
  "transparent": "button-module-scss-module__csTmNG__transparent",
});
